import _styled from "styled-components";
import Image from 'next/image';
import { PrivateModeProtectionCircleIcon, customImageLoader } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
export var ImageLogo = function ImageLogo(_ref) {
  var logo = _ref.logo;
  return /*#__PURE__*/_jsx(ImageWrapper, {
    children: logo ? /*#__PURE__*/_jsx(_StyledImage, {
      loader: customImageLoader,
      width: 80,
      height: 80,
      src: logo,
      alt: "company logo"
    }) : /*#__PURE__*/_jsx(PrivateModeProtectionCircleIcon, {})
  });
};
export default ImageLogo;

var ImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "image-logo__ImageWrapper",
  componentId: "sc-1q0lb3h-0"
})({
  "display": "flex",
  "height": "4.438rem",
  "width": "4.438rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(73 41 131 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "0.5rem"
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "image-logo___StyledImage",
  componentId: "sc-1q0lb3h-1"
})({
  "objectFit": "cover",
  "objectPosition": "center"
});